import { useContext } from 'react';

import { IS_JAPAN, useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormFieldGroup from '../../../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import TagField from '../../../../../formFields/tagField/tagField';
import TagCheckboxField from '../../../formFields/tagCheckboxField/tagCheckboxField';

const TagGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { brand } = useContext(CampaignFormContext);

  return (
    <CampaignFormFieldGroup
      label={languageTexts.create_tag_guidelines}
      wrapperClassName="!gap-7"
    >
      {/* 브랜드 공식계정 */}
      <TagField
        tagFieldName="AT_TAGS"
        label={languageTexts.create_brand_instagram_prompt}
        addButtonText="+"
      />

      {/* 타 브랜드 태그 허용 여부 */}
      <TagCheckboxField
        groupName={GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.ALLOW_OTHER_AT_TAG}
        label={languageTexts.create_other_brand_tags_prompt(brand.categoryId)}
      />

      {/* 해시 태그 */}
      <TagField
        tagFieldName="HASH_TAGS"
        label={languageTexts.create_sns_tags_prompt(brand.categoryId)}
        addButtonText="+"
      />

      {/* 브랜드 해시태그가 들어갈 위치 */}
      <TagCheckboxField
        groupName={GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.HASH_TAG_LOCATION}
        label={languageTexts.create_hashtag_location_prompt}
      />

      {/* 광고, 협찬 태그 허용 여부 */}
      {/* 일본의 경우 ALLOW를 기본 값으로 제공 */}
      {!IS_JAPAN && (
        <TagCheckboxField
          groupName={
            GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.ALLOW_ADVERTISEMENT_TAG
          }
          label={languageTexts.create_advertisement_tag}
        />
      )}
    </CampaignFormFieldGroup>
  );
};

export default TagGuidelineFieldGroup;
